export const DRIVER_GET_DRIVER_LIST = `
  query DriverGetDriverList($adminId: String, $userid: String) {
    driverGetDriverList(req: {
      adminId: $adminId
      userid: $userid
    }) {
      responseCode
      responseMessage
      data {
        id
        first_name
        last_name
        fullName
        driverId
        email
        phone
        username
        transport_type
        transport_description
        licence_plate
        tier
        status
        joiningDate
        last_login
        location_address
        location_lat
        location_lng
        device_id
        device_platform
        profile_photo
        dutyStatus
        driver_type
        shift_start
        shift_end
        teamid
        teamName
        driverIcon
        aadhar_no
        pan_no
        is_active_for_packer
        packer_team_id
      }
    }
  }
`;

